export const downloadFile = (
    url: string,
    setLoading: (loading: boolean) => void,
    setErrorMessage: (errorMessage: string) => void,
    handleSuccess: () => void,
    fileName: string,
    signal?: AbortSignal) => {

    fetch(url, {
        method: "GET",
        headers: {
            "Cache-Control": "no-cache",
            pragma: "no-cache"
        },
        signal: signal
    })
        .then(response => {
            if (!response.ok) {
                response.text().then(text => {
                    setErrorMessage("Fetch failed (" + (response.statusText && response.statusText !== "" ? response.statusText : text) + ").");
                    setLoading(false);
                });
            } else {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    setLoading(false);
                    handleSuccess();
                    a.remove();
                });
            }
        })
        .catch(error => {
            if (error.name !== "AbortError")
                setErrorMessage(error.message);
            setLoading(false);
        });

}

